<template>
  <div class="setting-delete-password">
    <SettingCard :is-open="isOpened" :is-password="true" @accordion="accordionToggle" @save="onClickSave">
      <template v-slot:title>
        削除パスワード設定
      </template>
      <template v-slot:notice>
        物件を削除する際に、パスワード入力を求めるか、求めないかの設定ができます。設定の変更には管理者パスワードが必要です。
      </template>

      <template v-slot:contents>
        <div style="margin-top: 16px;">
          <CheckboxBtn
            label="物件を削除する際にパスワードの入力を求める"
            :value.sync="permissions.f_cant_b_single_del"
            style="margin-bottom:10px;"
          />
          <CheckboxBtn
            label="物件を一括削除する際にパスワードの入力を求める"
            :value.sync="permissions.f_cant_b_bulk_del"
          />
        </div>
      </template>
    </SettingCard>
    <ModalPassword :modal.sync="modalPassword" @authentication="afterAuth" />
  </div>
</template>

<script>
import SettingCard from '@/components/parts/SettingCard'
import CheckboxBtn from '@/components/parts/CheckboxBtn'
import ModalPassword from '@/components/templates/modal/Password'
import SettingRepository from '@/repositories/settingRepository'
export default {
  components: {
    SettingCard,
    CheckboxBtn,
    ModalPassword,
  },

  data() {
    return {
      isOpened: false,
      modalPassword: false,
      permissions: {
        f_cant_b_single_del: 0,
        f_cant_b_bulk_del: 0,
      },
    }
  },
  computed: {},
  methods: {
    // アコーディオン 開閉処理
    accordionToggle: function() {
      if (!this.isOpened) {
        this.modalPassword = true
      } else {
        this.isOpened = false
        this.resetParams()
      }
    },
    // 認証後の処理
    afterAuth() {
      const permissions = _.cloneDeep(this.$store.getters['User/getPermissions'])
      this.permissions = permissions
      this.isOpened = true
    },
    // サイト設定登録処理
    async onClickSave() {
      this.$store.dispatch('Loading/setLoading', true)
      await SettingRepository.putPermissions(this.permissions)
        .then(data => {
          if (data.result) {
            const permissions = _.cloneDeep(this.permissions)
            this.$store.commit('User/setPermissions', permissions)
            alert('管理者情報を更新しました。')
          } else {
            alert('管理者情報の更新に失敗しました。')
          }
        })
        .catch(() => {
          alert('管理者情報の更新に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    resetParams() {
      this.permissions.f_cant_b_single_del = 0
      this.permissions.f_cant_b_bulk_del = 0
    },
  },
}
</script>

<style lang="scss" scoped>
.setting-delete-password {
}
</style>
